import React, { useState, useEffect } from 'react';
import { Galleria } from 'primereact/galleria';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(false);
    const navigate = useNavigate();

    // Array de slides con contenido y rutas de imágenes
    const slides = [
        {
            id: 1,
            title: "¡Sorprende a Papi con la Mejor Tecnología!",
            description: "Encuentra el regalo perfecto para él: \nlaptops de gama profesional, estudio y gaming con súper descuentos.\nGarantía oficial, comprobante electrónico (Boleta/Factura) y envío seguro a todo el Perú.",
            buttonText: "Ver Catálogo",
            buttonLink: "/catalogo/laptops",
            desktopImage: "/slides/1920x1080-slide1.jpg",
            mobileImage: "/slides/800x450-slide1.jpg",
            alt: "Laptop ideal para estudios, trabajo y gaming"
        },
        {
            id: 2,
            title: "Compra 100% Segura: Tu Laptop Soñada, a Pedido o Recojo presencial",
            description: "Todos nuestros equipos cuentan con garantía, boleta o factura de compra, y asesoría especializada vía WhatsApp durante todo el proceso.",
            buttonText: "Hablar con un Asesor",
            buttonLink: "https://wa.me/51978326796",
            desktopImage: "/slides/1920x1080-slide2.jpg",
            mobileImage: "/slides/800x450-slide2.jpg",
            alt: "Legion Pro 7i laptop gaming"
        }
    ];

    // Detectar tamaño de pantalla
    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth < 992);
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);

        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // Template para cada slide
    const itemTemplate = (slide) => {
        return (
            <div className="relative w-full h-full overflow-hidden">
                {/* Imagen como fondo */}
                <img
                    src={isMobile ? slide.mobileImage : slide.desktopImage}
                    alt={slide.alt}
                    className="absolute inset-0 w-full h-full object-cover object-center"
                    style={{ zIndex: 0 }}
                />

                {/* Overlay gradient */}
                <div className="absolute inset-0 bg-gradient-to-r from-black-alpha-70 via-black-alpha-40 to-black-alpha-10" style={{ zIndex: 1 }} />

                {/* Contenido del texto */}
                <div className="absolute inset-0 flex align-items-center justify-content-start p-4 lg:p-6 xl:p-8 w-full" style={{ zIndex: 2 }}>
                    <div className="w-full lg:w-6 xl:w-5">
                        <h1 className="hero-title-gradient text-2xl lg:text-4xl xl:text-5xl font-bold mb-3 lg:mb-4 line-height-3 w-full">
                            {slide.title.split('\n').map((line, index) => (
                                <span key={index}>
                                    {line}
                                    {index < slide.title.split('\n').length - 1 && <br />}
                                </span>
                            ))}
                        </h1>
                        <p className="text-white text-base lg:text-lg xl:text-xl mb-4 lg:mb-6 line-height-3 opacity-90 w-full lg:w-9" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.8)' }}>
                            {slide.description.split('\n').map((line, index) => (
                                <span key={index}>
                                    {line}
                                    {index < slide.description.split('\n').length - 1 && <br />}
                                </span>
                            ))}
                        </p>
                        <Button
                            label={slide.buttonText}
                            className="p-button-primary"
                            raised
                            onClick={() => window.open(slide.buttonLink, '_self')}
                        />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="hero-slider-wrapper relative w-full overflow-hidden">
            <Galleria
                value={slides}
                activeIndex={activeIndex}
                onItemChange={(e) => setActiveIndex(e.index)}
                item={itemTemplate}
                showItemNavigators
                showIndicators
                showThumbnails={false}
                circular
                autoPlay
                transitionInterval={5000}
                className="hero-galleria w-full h-full"
                pt={{
                    root: { className: 'w-full h-full' },
                    content: { className: 'w-full h-full' },
                    itemWrapper: { className: 'w-full h-full' },
                    item: { className: 'w-full h-full' },
                    indicators: { className: 'hero-galleria-indicators' },
                    indicator: { className: 'hero-galleria-indicator' }
                }}
            />
        </div>
    );
};

export default HeroSection;
